import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useAnalytics } from '@lusha-engage/analytics';
import { useAppSelector } from '@reducers/index';
import { Button, Doodles, IconButton, Text } from 'lusha-ui-components-v2';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { IconFactory } from '../../assets/icons/IconFactory';
import { showAnnouncement } from '../../utils/announcements';
import './Pricing295UnlimitedExceededPopup.scss';
export const USE_BULK_KEY = 'USE_BULK_CREDITS_SESSION';
const showPricing295UnlimitedExceededPopup = () => showAnnouncement(Pricing295UnlimitedExceededPopup, 1000, { withHeader: false });
const shouldUseBulkCredits = () => sessionStorage.getItem(USE_BULK_KEY) === 'true';
const CONFIG = {
    BULK: {
        PARAGRAPH: 'Your unlimited user access to manually reveal contacts has been restricted due to suspicious monthly user activity.\n\nPlease reach out to your Customer Success Manager to resolve your user access. Your account access to your Bulk Credits remains available.',
        BUTTON: 'Use bulk credits',
        EVENT_TYPES: {
            VIEWED: 'confirm_bulk_action_popup_viewed',
            CLOSED: 'confirm_bulk_action_popup_dismissed',
            CLICKED: 'confirm_bulk_action_popup_clicked',
        },
        onClick: () => {
            sessionStorage.setItem(USE_BULK_KEY, 'true');
        },
    },
    OUT_OF_CREDITS: {
        PARAGRAPH: 'Your unlimited user access to manually reveal contacts has been restricted due to suspicious monthly user activity.\n\nPlease reach out to your Customer Success Manager to resolve your user access.',
        BUTTON: 'Got it',
        EVENT_TYPES: {
            VIEWED: 'reached_monthly_unlimited_contacts_popup_viewed',
            CLOSED: 'reached_monthly_unlimited_contacts_popup_dismissed',
            CLICKED: 'reached_monthly_unlimited_contacts_popup_clicked',
        },
    },
};
const Pricing295UnlimitedExceededPopup = observer(({ closePopup }) => {
    const { bulkAvailableCredits } = useAppSelector(state => ({ bulkAvailableCredits: state.user.bulkAvailableCredits }));
    const analytics = useAnalytics();
    const config = bulkAvailableCredits > 0 ? CONFIG.BULK : CONFIG.OUT_OF_CREDITS;
    useEffect(() => {
        analytics.track({ eventType: config.EVENT_TYPES.VIEWED });
    }, []);
    const onClose = () => {
        analytics.track({ eventType: config.EVENT_TYPES.CLOSED, event_value: 'close' });
        closePopup();
    };
    const onClick = () => {
        analytics.track({ eventType: config.EVENT_TYPES.CLICKED, event_value: config.BUTTON });
        closePopup();
        config.onClick && config.onClick();
    };
    return (_jsxs("div", { className: "pricing295-unlimited-exceeded-container", children: [_jsx(IconButton, { variant: "primary", onClick: onClose, className: "pricing295-unlimited-exceeded-close-btn", children: IconFactory('Close') }), _jsxs("div", { className: "pricing295-unlimited-exceeded-main", children: [_jsx(Doodles.AlertDialog, { size: "large" }), _jsx(Text, { variant: "largeM", className: "pricing295-unlimited-exceeded-title", children: "Your user access has been restricted due to suspicious monthly user activity" }), _jsx(Text, { variant: "mediumR", color: "darkGrey", className: "pricing295-unlimited-exceeded-text", children: config.PARAGRAPH }), _jsx(Button, { size: "small", className: "pricing295-unlimited-exceeded-button", onClick: onClick, children: config.BUTTON })] })] }));
});
export default Pricing295UnlimitedExceededPopup;
export { shouldUseBulkCredits, showPricing295UnlimitedExceededPopup };
Pricing295UnlimitedExceededPopup.propTypes = {
    closePopup: PropTypes.func.isRequired,
};
